import { headline } from "../landing-copy";
import TypeIn from "./TypeIn";

export default function Headline() {
  return (
    <h1 className="headline">
      <span className="headline-primary">
        <TypeIn text={headline.primary} delay={0.02} step={0.01} />
      </span>
      <br />
      <span className="headline-secondary">
        <TypeIn text={headline.secondary} delay={0.22} step={0.01} />
      </span>
    </h1>
  );
}
